import { ArgTypes } from '../utils/ArgValidation';
import { $TSFixMe } from '../utils/typescript';
import { getModelHelpers, InferConstructorArgTypes, InferReadTypes, toJSON } from './Model';
import HealthCheckResult from './HealthCheckResult';

export default class StorageHealthCheckResult extends getModelHelpers({
  storageSpace: { type: ArgTypes.instanceOf(HealthCheckResult) },
}, 'StorageHealthCheckResult')(({ RecordClass, typesAndDefaults, checkConstructorArgs, checkSetArgs }) => {
  type ConstructorArgTypes = InferConstructorArgTypes<typeof typesAndDefaults>;
  type ReadTypes = InferReadTypes<typeof typesAndDefaults>;
  return class HealthCheckResultRecord extends RecordClass {
    constructor(args: ConstructorArgTypes) {
      checkConstructorArgs(args);
      super(args);
    }
    set<T extends keyof ReadTypes>(name: T, value: ReadTypes[T]) {
      checkSetArgs(name, value);
      return super.set(name, value);
    }
  };
}) {
  static get argType() { return ArgTypes.instanceOf(this); }

  toJSON() {
    return toJSON(super.toJSON());
  }

  static fromJSON(obj: $TSFixMe) {
    return new StorageHealthCheckResult({
      storageSpace: obj.storageSpace,
    });
  }
}
